import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ScatterPlotChartComponent } from './scatter-plot-chart.component';
import type { ScatterPlotDisplayConfig, ScatterPlotParams } from './scatter-plot-chart.model';

@Component({
  selector: 'dojo-scatter-plot-explain',
  standalone: true,
  imports: [ScatterPlotChartComponent],
  template: `<dojo-scatter-plot-chart [params]="params()" [display]="display()" />`,
  host: { class: 'block w-full h-full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScatterPlotExplainComponent {
  readonly params = input.required<ScatterPlotParams>();
  readonly display = input<ScatterPlotDisplayConfig>({});
}
